import { useConfiguration } from "@src/api/configurations/use-configuration";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useLoggedInUser } from "@src/api/user-auths/login";

/**
 * Whether the Advanced tab of an Agentic Logic rule is visible — the raw rule
 * code or configuration, the publish gates and the version history.
 *
 * Separate from `agentic_logic_enabled`, which decides whether the org has
 * Agentic Logic at all: an org can author and run rules from the readable
 * surfaces without ever being shown the expert view.
 *
 * Intelligems admins always see it. The Advanced tab is where a rule is
 * actually diagnosed, so gating it on a per-org toggle would leave support
 * unable to look at the rule the merchant is asking about.
 */
export const useIsAdvancedAgenticLogicEnabled = (): boolean => {
  // Both hooks run unconditionally — `||` between two hook calls would skip
  // one of them on the admin path and break the hook order.
  const isAdmin = useIsAdmin() === true;
  const user = useLoggedInUser();
  const toggle = !!useConfiguration<boolean>("advanced_agentic_logic_enabled")
    ?.value;

  const admins = ["christian@intelligems.io"];

  return toggle || (user.isSuccess && admins.includes(user.data?.user.email));
};
